import './js/components/pwa'
import './js/components/bn_theme-switcher'
import './js/components/browsingHistoryLoad'
import './js/layout/header'
import './js/components/flashNotifier'
import './js/components/input-counter'
import './js/components/scrollTo'
import './js/components/bn_popup'
import './js/components/bn_forms'
import './js/components/bn_swiper'
import './js/components/bn_blog-card'
import './js/components/bn_share'
import './js/components/bn_back'
import './js/modules/modules'
import './js/modules/help-centre/help-centre'
// WIDGETS
import './js/widgets'
import './js/components/customDropdown'
import './js/widgets/bookCard'
import './js/components/scroll'
import './js/components/fixedSidebar'
import './js/components/clipboard'
import './js/components/uploader'
import './js/components/bn_spinner'
import './js/components/bn_commerce-stat'
import './js/components/bn_comments'

// SCSS
import './scss/main.scss';